import { render, staticRenderFns } from "./SectionsSuc.vue?vue&type=template&id=6a1917ef&scoped=true&"
import script from "./SectionsSuc.vue?vue&type=script&lang=js&"
export * from "./SectionsSuc.vue?vue&type=script&lang=js&"
import style0 from "./SectionsSuc.vue?vue&type=style&index=0&id=6a1917ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1917ef",
  null
  
)

export default component.exports